import { render, staticRenderFns } from "./vue-confirm-dialog.vue?vue&type=template&id=b2af17da&"
import script from "./vue-confirm-dialog.vue?vue&type=script&lang=js&"
export * from "./vue-confirm-dialog.vue?vue&type=script&lang=js&"
import style0 from "./vue-confirm-dialog.vue?vue&type=style&index=0&id=b2af17da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports